import { z } from 'zod';

const featureCheck = z.object({
  valid: z.boolean({ required_error: 'กรุณาเลือกตัวเลือกใดตัวเลือกหนึ่ง' }),
  additionalInfo: z.string().optional(),
});

const featureCheckWithImages = featureCheck.extend({
  images: z.array(z.string()).min(1, { message: 'กรุณาแนบรูปถ่ายอย่างน้อย 1 รูป' }).default([]),
});

const doorInfo = z.object({
  numberOfDoors: z
    .number({ required_error: 'กรุณาระบุจำนวนประตูห้องสอบ' })
    .min(1, { message: 'กรุณาระบุจำนวนประตูห้องสอบ อย่างน้อย 1 ประตู' }),
  images: z.array(z.string()).min(1, { message: 'กรุณาแนบรูปถ่ายอย่างน้อย 1 รูป' }).default([]),
});

const photoSet = z.object({
  images: z.array(z.string()).min(1, { message: 'กรุณาแนบรูปถ่ายอย่างน้อย 1 รูป' }).default([]),
});

const examLocationRequestRoomPhysicalInfoFormSchema = z.object({
  // Physical Properties
  seatSideSpacing: featureCheck,
  screenDistance: featureCheck,
  seatFrontBackSpacing: featureCheck,
  windows: featureCheck,
  storageLocker: featureCheck,
  examineeStorage: featureCheck,
  securityCameras: featureCheckWithImages,
  entryExitDoors: doorInfo,
  frontOfExamRoom: photoSet,
  insideExamRoom: photoSet,

  // Area around the exam room
  registrationArea: featureCheckWithImages,
  toilets: featureCheck,
  sharedOpenArea: featureCheck,
});

type ExamLocationRequestRoomPhysicalInfoFormInputs = z.infer<
  typeof examLocationRequestRoomPhysicalInfoFormSchema
>;

export {
  examLocationRequestRoomPhysicalInfoFormSchema,
  ExamLocationRequestRoomPhysicalInfoFormInputs,
};
